import Image from 'next/image';

import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import SectionDynamic from './SectionDynamic';

const useStyles = makeStyles(theme => ({
  fontWeight700: {
    fontWeight: 700,
  },
  imgWrapper: {
    position: 'relative',
    width: 100,
    height: 100,
  },
  logoImg: {
    filter: 'grayscale(100%)',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.complex,
    }),
    '&:hover': {
      filter: 'grayscale(0%)',
    },
  },
}));

export default function Partners(props) {
  const { className, section, title, partners = [], refElem, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        <Grid container spacing={2}>
          {title && (
            <Grid item xs={12}>
              <Typography
                variant="h6"
                component="div"
                color="textSecondary"
                align="center"
                className={classes.fontWeight700}>
                {title}
              </Typography>
            </Grid>
          )}
          {partners.length > 0 && (
            <Grid item xs={12}>
              <Grid item container spacing={isMd ? 4 : 2} justifyContent="space-between">
                {partners.map((partner, index) => (
                  <Grid item container justifyContent="center" xs={6} sm={2} key={index.toString()}>
                    <div className={classes.imgWrapper}>
                      {partner.logo?.url && (
                        <Image
                          src={partner.logo?.url}
                          alt={partner.name || 'parceiro'}
                          className={classes.logoImg}
                          layout="fill"
                          objectFit="contain"
                          quality={60}
                        />
                      )}
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    </SectionDynamic>
  );
}

Partners.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  partners: PropTypes.array.isRequired,
  refElem: PropTypes.any,
};
